export const pedantBaseCurrencyFix = (currencyName: string) => {
  if (currencyName === 'руб.') return 'RUB'

  return currencyName
}
